<div class="p-5">
  <app-wrapper header="Consultant Details" id="full-page-content">
    <!-- Consultant Header -->
    <div class="mb-3">
      <app-common-header
        [firstName]="consultant?.firstName ?? '--'"
        [lastName]="consultant?.lastName ?? '--'"
        [id]="consultant?.consultantId ?? '--'"
        [title]="consultant?.title ?? '--'"
        [isFavIconVisible]="false"
        (onFavClick)="handleFavClick($event)"
        [isResumeVisible]="false"
        [isVideoVisible]="false"
        [isShareButtonVisible]="true"
        (downloadPdf)="downloadFullPageAsPDF()"
      >
      </app-common-header>
    </div>

    <!-- Info Card -->
    <div class="bg-white">
      <p-card>
        <ng-template pTemplate="content">
          <!-- Profile Details -->
          <section>
            <h3 class="text-2xl font-bold text-gray-900">Profile Details</h3>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-3 gap-x-8 text-gray-900">
              <!-- Card 1 -->
              <div
                class="bg-white min-w-[150px] flex-1 shadow-sm p-6 border-style border-l-4 border-t-0 border-b-0 border-r-0 rounded-xl border-solid border-primary">
                <div class="flex gap-3">
                  <span class="block font-semibold text-gray-500">Work Experience:</span>
                  <div class="text-xl font-semibold leading-tight">
                    {{
                      consultant
                        ? ((consultant.experienceYear != null || consultant.experienceMonth != null)
                          ? ((consultant.experienceYear ? consultant.experienceYear + 'y' : '') +
                            (consultant.experienceMonth ? ' ' + consultant.experienceMonth + 'm' : '')).trim()
                          : '--')
                        : '--'
                    }}
                  </div>
                </div>
              </div>

              <!-- Card 2 -->
              <div
                class="bg-white min-w-[150px] flex-1 shadow-sm p-6 border-style border-l-4 border-t-0 border-b-0 border-r-0 rounded-xl border-solid border-primary">
                <div class="flex gap-3">
                  <span class="block font-semibold text-gray-500">Degree:</span>
                  <div class="font-semibold leading-tight">
                    {{ consultant?.education?.name ?? '--' }}
                  </div>
                </div>
              </div>

              <!-- Card 3 -->
              <div
                class="bg-white min-w-[150px] flex-1 shadow-sm p-6 border-style avoid-break border-l-4 border-t-0 border-b-0 border-r-0 rounded-xl border-solid border-primary">
                <div class="flex gap-3">
                  <span class="block font-semibold text-gray-500">Location Preference:</span>
                  <div class="font-semibold leading-tight whitespace-nowrap max-w-full">
                    {{ consultant?.jobType ?? '--' }}
                  </div>
                </div>
              </div>

              <!-- Card 4 -->
              <div
                class="bg-white min-w-[150px] flex-1 shadow-sm p-6 border-style border-l-4 border-t-0 border-b-0 border-r-0 rounded-xl border-solid border-primary">
                <div class="flex gap-3">
                  <span class="block font-semibold text-gray-500">Availability To Join:</span>
                  <div class="font-semibold leading-tight">
                    {{ consultant?.availabilityToJoin ?? '--' }}
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div
            class="bg-white min-w-[250px] flex-1 shadow-sm p-6 border-style mt-3 border-l-4 border-t-0 border-b-0 border-r-0 rounded-xl border-solid border-primary">
            <div class="flex gap-3">
              <span class="block font-semibold text-gray-500">Skills:</span>
              <div class="flex flex-wrap gap-2 ms-2">
                @for (s of consultant?.skills ?? []; track $index) {
                  <p-tag [value]="s.skill && s.skill.title || '--'" severity="info"
                         class="!text-[10px] !px-3 !py-1"></p-tag>
                } @empty {
                  <p-tag [value]="'--'" severity="info" class="!text-sm !px-3 !py-1"></p-tag>
                }
              </div>
            </div>
          </div>

          <!-- Technical Summary -->
          <section>
            <h3 class="text-xl font-semibold text-gray-800">Technical Summary</h3>
            <div
              class="bg-gray-50 border border-gray-200 rounded-md p-4 text-gray-700 text-sm leading-relaxed whitespace-pre-line"
              [innerHTML]="consultant?.summary ?? '--'">
            </div>
          </section>
        </ng-template>
      </p-card>
    </div>
  </app-wrapper>
</div>
